// src/actions/userActions.ts
import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchCompany} from 'sr/utils/api/fetchCompany'

// Cache guard: skip fetch if data is already loaded in Redux store
export const fetchCompanyData = createAsyncThunk(
  'company/fetchCompanyData',
  async (payload: any) => {
    // Only fetch id + company_name (projection) with a reasonable batch size
    // The backend's aqp supports 'select' to limit returned fields
    const response = await fetchCompany({
      ...payload,
      limit: 10000,
      select: 'company_name',
    })
    const data: {company_name: string; id: string}[] = []
    const idNameMap: {[key: string]: string} = {}
    response.data.forEach((com: any) => {
      idNameMap[com.id || com._id] = com.company_name
      data.push({
        company_name: com.company_name,
        id: com.id || com._id,
      })
    })
    return {
      data,
      idNameMap,
    }
  },
  {
    // Prevent re-fetching if already loaded
    condition: (_payload, { getState }) => {
      const { company } = getState() as { company: { status: string } }
      if (company.status === 'succeeded' || company.status === 'loading') {
        return false // Skip this fetch
      }
      return true
    },
  }
)
